
import { ref } from "vue";
import { User } from "@/types/user.type";
import { ElRowClassNameParams } from "@/types/element.type";
import { ElMessage, ElMessageBox } from "element-plus";
import { defineComponent } from "vue";
import PageHeaderComponent from "../PageHeader.component.vue";
import UserFormComponent from "../users/UserForm.component.vue";
import { changeActivateUser, getUserPage, searchUser } from "@/service/user.service";
import { errorHandlerDefault } from "@/utils/handler.util";
import { deleteUser } from "@/service/user.service";

export default defineComponent({
  components: { PageHeaderComponent, UserFormComponent },
  data() {
    return {
      users: [] as User[],
      currentPage: 0 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      showUserForm: false,
      userForm: undefined as undefined | User,
      permissionsNames: [] as string[],
      visible: false,
      checked: false,
      tooltipString: "",
      searchedUser: "",
      userSelected: {} as User,
    };
  },
  mounted() {
    //console.log("userPermissions en Vue:", this.userPermissions);
    this.currentPage = 1;
    this.refreshUser();
  },
  methods: {
    /**
     * table row css class name
     * @param {ElRowClassNameParams<Container>} params
     * @return {string} css class name
     */
    tableRowClassName(params: ElRowClassNameParams<User>): string {
      return params.row && params.row.active ? "" : "disable-row";
    },

    /**
     * open container formDialog
     * @param item
     */
    openUserFormDialog(item: User) {
      this.userSelected = item;
      this.showUserForm = true;
    },
    /**
     * set page
     * @param {number} page
     */
    onSizeChange(size: number): void {
      this.rowPerPage = size;
      this.refreshUser();
    },

    /**
     * change page
     * @param {number} page
     */
    onCurrentChange(page: number): void {
      this.currentPage = page;
      this.refreshUser();
    },

    /**
     * confirm activate item
     * @param {Container} item
     */
    confirmActivateItem(item: User) {
      ElMessageBox.confirm(
        this.$t("confirm.activateUser", { name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          // - accept
          this.changeStatusUser(item, true);
        })
        .catch(() => void 0);
    },

    /**
     * confirm deactivate action
     * @param {Container} item
     */
    confirmDeactivateItem(item: User) {
      ElMessageBox.confirm(
        this.$t("confirm.deactivateUser", { name: item.id }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          // - accept
          this.changeStatusUser(item, false);
        })
        .catch(() => void 0);
    },

    async confirmDeleteUser(item: User) {
      ElMessageBox.confirm(
        this.$t("confirm.deleteUser", { email: item.email, name: item.name }),
        this.$t("label.warning"),
        {
          confirmButtonText: this.$t("btn.accept"),
          cancelButtonText: this.$t("btn.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          deleteUser(item.id);
          ElMessage.success(`${"Usuario eliminado"}`);
          this.refreshUser();
        })
        .catch(() => void 0);
    },

    /*
     * change status container
     * @param {User} item
     * @param {boolean} active
     */
    changeStatusUser(item: User, active: boolean) {
      if (!item.id) return;
      // TODO el servicio debe retornar el item
      changeActivateUser(item.id).then(() => {
        ElMessage.success(this.$t("success.action"));
        // - refrehs item
        this.refreshUser({ ...item, active });
      });
    },

    /**
     * refresh container item from list items
     * @param {User|undefined=undefined} item
     */
    refreshUser(item: User | undefined = undefined) {
      let index = -1;
      if (this.users && item) {
        index = this.users.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.users[index] = item;
      } else if (this.searchedUser !== "") {
        searchUser(
          (this.currentPage - 1) * this.rowPerPage,
          this.rowPerPage,
          this.searchedUser
        ).then((pagination) => {
          this.totalRows = pagination.totalRows;
          this.users = pagination.data;
        });
      } else {
        getUserPage((this.currentPage - 1) * this.rowPerPage, this.rowPerPage).then(
          (pagination) => {
            this.totalRows = pagination.totalRows;
            this.users = pagination.data;
          }
        );
      }
    },

    /**
     * close container formDialog
     */
    closeUserFormDialog() {
      this.showUserForm = false;
      this.userForm = undefined;
    },

    /**
     * modify user
     */
    modifyUser() {
      // - call userForm save method
      (this.$refs["userForm"] as InstanceType<typeof UserFormComponent>)
        .modifyUser()
        .then(() => {
          this.closeUserFormDialog();
          this.refreshUser();
          ElMessage.success(this.$t("success.action"));
        })
        .catch(errorHandlerDefault);
    },

    restoreUser() {
      (this.$refs["userForm"] as InstanceType<typeof UserFormComponent>).resetUser();
    },
    /**
     * Get a list of names
     * @param {any} object
     */
    getListNameObject(object: any) {
      let nameRole = "";
      for (const o in object) {
        nameRole += ` ${object[o].name},`;
      }
      nameRole = nameRole.substring(0, nameRole.length - 1);
      this.tooltipString = nameRole;
      return nameRole;
    },
    /**
     * Convert an object owned by a table to an array to displayed names
     * @param {any} object Object to covert to array
     * @param {string} type Object type
     */
    convertObjectToArray(object: any, type: string) {
      return Object.keys(object).map(function (objectNamedIndex) {
        let item = object[objectNamedIndex];
        if (type === "permissions") {
          if (item.name === "Usuario Calidad visualizador") {
            item.name = item.name.replace("Usuario Calidad visualizador", "U.C.Visualizador");
          } else if (item.name === "Usuario Calidad Configurador") {
            item.name = item.name.replace("Usuario Calidad Configurador", "U.C.Configurador");
          } else if (item.name === "Usuario Calidad Agente de campo") {
            item.name = item.name.replace("Usuario Calidad Agente de campo", "U.C.Agente de Campo");
          } else if (item.name === "Usuario técnico gestión de estaciones visualizador") {
            item.name = item.name.replace(
              "Usuario técnico gestión de estaciones visualizador",
              "U.E.Visualizador"
            );
          } else if (item.name === "Usuario técnico gestión de estaciones configurador") {
            item.name = item.name.replace(
              "Usuario técnico gestión de estaciones configurador",
              "U.E.Configurador"
            );
          } else if (
            item.name === "Usuario técnico gestión de estaciones operación/mantenimiento campo"
          ) {
            item.name = item.name.replace(
              "Usuario técnico gestión de estaciones operación/mantenimiento campo",
              "U.E.Mantenimiento"
            );
          }
        }
        return item;
      });
    },
  },
});
